import { SortDirection } from '@angular/material/sort';

export interface BaseTableParams {
  searchFilter: unknown;
  sortDirection: SortDirection;
  pageIndex: number;
  pageSize: number;
  sortField: string;
}
